/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Pace_FormatInputs */

const en_ui_thresholds_pace_format = /** @type {(inputs: Ui_Thresholds_Pace_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format: m:ss (2:30-9:00)`)
};

const de_ui_thresholds_pace_format = /** @type {(inputs: Ui_Thresholds_Pace_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format: m:ss (2:30-9:00)`)
};

/**
* | output |
* | --- |
* | "Format: m:ss (2:30-9:00)" |
*
* @param {Ui_Thresholds_Pace_FormatInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_pace_format = /** @type {((inputs?: Ui_Thresholds_Pace_FormatInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Pace_FormatInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_pace_format(inputs)
	return de_ui_thresholds_pace_format(inputs)
});